import { BehaviorSubject } from "rxjs";
import { IConfig } from "./config.interface";
import { AuthGuard } from "./core/guards/auth.guard";

const config = <IConfig>Object.assign({}, window['environment']);
export const configurationSubject = new BehaviorSubject<IConfig>(config);

export function resolveOauthConfig() {
  const oauth = configurationSubject.getValue().oauth;
  const policy = sessionStorage.getItem('policy');
  if (policy) {
    oauth.authority = oauth.authority!.replace(AuthGuard.B2C_POLICY_REGEX.exec(oauth.authority!)![1], policy);
  }
  const clientId = sessionStorage.getItem('client_id')
  if (clientId) {
    oauth.client_id = clientId;
  }
  return oauth;
}

export function resolveEnvironment() {
  return configurationSubject.getValue().environment;
}

export function resolveHeliosSso() {
  return configurationSubject.getValue().heliosSso;
}

export function resolveLegacySso() {
  return configurationSubject.getValue().polLegacySso;
}

export function resolveLaunchDarkly() {
  return configurationSubject.getValue().launchDarkly;
}
